import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { TConsentCookieProps } from './types/consentCookie.types';

const ConsentCookie: FC<TConsentCookieProps> = (props) => {
  if (
    props?.sitecoreContext?.route?.databaseName === 'master' ||
    !props?.sitecoreContext?.consentCookie?.cookieKey ||
    props?.sitecoreContext?.pageState !== 'normal'
  ) {
    return null;
  }

  const documentLangAttribute = props?.sitecoreContext?.consentCookie?.isHtmlLanguageDetected ? { 'data-document-language': 'true' } : {};

  return (
    <Helmet>
      {props?.sitecoreContext?.consentCookie?.isAutoBlockingEnabled && (
        <script
          type="text/javascript"
          src={`https://cdn.cookielaw.org/consent/${props?.sitecoreContext?.consentCookie?.cookieKey}/OtAutoBlock.js`}
        ></script>
      )}
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script={props?.sitecoreContext?.consentCookie?.cookieKey}
        {...documentLangAttribute}
      ></script>
      {props?.sitecoreContext?.consentCookie?.oneTrustStyle && (
        <link
          rel="stylesheet"
          type="text/css"
          href={props?.sitecoreContext?.consentCookie?.oneTrustStyle}
        />
      )}
    </Helmet>
  );
};

export default withSitecoreContext()(React.memo(ConsentCookie));
